import { render, staticRenderFns } from "./TheTicketResponseBox.vue?vue&type=template&id=f2e04016&scoped=true"
import script from "./TheTicketResponseBox.vue?vue&type=script&lang=js"
export * from "./TheTicketResponseBox.vue?vue&type=script&lang=js"
import style0 from "./TheTicketResponseBox.vue?vue&type=style&index=0&id=f2e04016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e04016",
  null
  
)

export default component.exports